module.exports = __webpack_public_path__ + "img/9788980403486.7a1520aa.jpg";